import { useEffect, useState } from "react";
import { PageTabs } from "../component/list/PageTabs";

// ui
import { Box } from "@mui/material";

// Table
import { ConstTable } from "../component/Table";
import { TableRunking } from "../component/TableRunking";

// Bar
import TableTopBar from "../component/TableTopBar";
import { SerchSideBar } from "../component/SerchSideBar";

// Modal
import { DataAddModalResult } from "../component/DataAddModalResult";
import { ColumnSettingModal } from "../component/ColumnSettingModal";
import { GetXLSXRankingModal } from "../component/GetXLSXRankingModal";

// jotai
import { useAtomValue, useSetAtom } from "jotai";
import { AppAtoms } from "../lib/store";

// API
import { getAccountRunkings } from "../api/accountRunking";
import {
  getSerchHighRankCompanys,
  getSerchCategorys,
  getSerchProducts,
  getSerchSaleCompanys,
  getSerchSaleCompanyGroups,
  getSerchAccountSales,
} from "../api/serch";
import {
  getScreenColumns,
  getScreenColumnAccountRunkings,
  putScreenColumnAccountRunkings,
} from "../api/screenColumn";

// InterFace
import { accountRunkingTableColumn } from "../config/accountRunking";
import {
  dataDifine,
  subDataDifine,
  EditDataDifine,
} from "../config/dataInterface";

// OtherFunc
import { getFirstYear, getOneYear } from "../lib/other";
import { CONST } from "../config/const";
import axios from "axios";
import { makeParams } from "../api/common";

function AccountRunking() {
  const loginUser = useAtomValue(AppAtoms.loginUser);
  const isSmartPhone = useAtomValue(AppAtoms.isSmartPhone);
  const accountRunkingScreenColumn = useAtomValue(
    AppAtoms.accountRunkingScreenColumn,
  );
  const setAccountRunkingScreenColumn = useSetAtom(
    AppAtoms.accountRunkingScreenColumn,
  );
  const setIsLoading = useSetAtom(AppAtoms.isLoading);

  // 各権限毎のヘッダーメニューの編集
  const addDataTypes: { auth: string[]; name: string }[] = [];
  const addCSVDataTypes: { auth: string[]; name: string }[] = [];
  const getXLSXDataTypes: { auth: string[]; name: string }[] = [
    {
      auth: ["マスターアカウント", "スタッフアカウント", "パートナー", "営業アカウント"],
      name: "ランキング一覧出力",
    },
  ];
  const editDatasTypes: { auth: string[]; name: string }[] = [];

  const [addDataNames, setAddDataNames] = useState<string[]>([]);
  const [addDataName, setAddDataName] = useState<string>("");
  const [addCSVDataNames, setAddCSVDataNames] = useState<string[]>([]);
  const [addCSVDataName, setAddCSVDataName] = useState<string>("");
  const [getXLSXDataNames, setGetXLSXDataNames] = useState<string[]>([]);
  const [getXLSXDataName, setGetXLSXDataName] = useState<string>("");
  const [editDatasNames, setEditDatasNames] = useState<string[]>([]);
  const [editDatasName, setEditDatasName] = useState<string>("");

  useEffect(() => {
    let addDataNames: string[] = [];
    let addCSVDataNames: string[] = [];
    let getXLSXDataNames: string[] = [];
    let editDatasNames: string[] = [];
    addDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        addDataNames.push(dataType.name);
      }
    });
    setAddDataNames(addDataNames);
    addCSVDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        addCSVDataNames.push(dataType.name);
      }
    });
    setAddCSVDataNames(addCSVDataNames);
    getXLSXDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        getXLSXDataNames.push(dataType.name);
      }
    });
    setGetXLSXDataNames(getXLSXDataNames);
    editDatasTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        editDatasNames.push(dataType.name);
      }
    });
    setEditDatasNames(editDatasNames);
  }, [loginUser]);

  useEffect(() => {}, [addDataName]);

  useEffect(() => {}, [addCSVDataName]);

  const [getXLSXStatus, setGetXLSXStatus] = useState<{
    status: "none" | "open" | "getting" | "result" | "loading" | "error";
    message: string;
  }>({
    status: "none",
    message: "",
  });

  useEffect(() => {
    if (getXLSXDataName === "ランキング一覧出力") {
      setGetXLSXStatus({ ...getXLSXStatus, status: "open" });
    }
  }, [getXLSXDataName]);

  // サブテーブルデータの一覧取得
  const [getSubTableName, setGetSubTableName] = useState<{
    name: string;
    key: { [key: string]: string };
    subData: subDataDifine[];
  }>({
    name: "",
    key: {},
    subData: [],
  });
  useEffect(() => {}, [getSubTableName.name, getSubTableName.key]);

  // サブテーブルデータの詳細取得
  const [getSubTableDetail, setGetSubTableDetail] = useState<{
    name: string;
    key: { [key: string]: string };
    dataDetail: {
      [key: string]:
        | number
        | string
        | { [key: string]: string | number }[]
        | { [key: string]: string | string[] };
    } | null;
  }>({
    name: "",
    key: {},
    dataDetail: null,
  });
  useEffect(() => {}, [getSubTableDetail.name, getSubTableDetail.key]);

  // サブテーブルデータの登録
  const [getSubTableAdd, setGetSubTableAdd] = useState<{
    name: string;
    row: dataDifine | null;
  }>({
    name: "",
    row: null,
  });
  useEffect(() => {}, [getSubTableAdd.name, getSubTableAdd.row]);

  // サブサブテーブルデータの一覧取得
  const [getSubSubTableName, setGetSubSubTableName] = useState<{
    name: string;
    key: { [key: string]: string };
    subData: subDataDifine[];
  }>({
    name: "",
    key: {},
    subData: [],
  });
  useEffect(() => {}, [getSubSubTableName.name, getSubSubTableName.key]);

  // サブテーブルデータの登録
  const [getSubSubTableAdd, setGetSubSubTableAdd] = useState<{
    name: string;
    row: dataDifine | null;
  }>({
    name: "",
    row: null,
  });
  useEffect(() => {}, [getSubSubTableAdd.name, getSubSubTableAdd.row]);

  const [tableOriginalFunc, setTableOriginalFunc] = useState<{
    name: string;
    key: { [key: string]: string };
  }>({
    name: "",
    key: {},
  });
  useEffect(() => {}, [tableOriginalFunc.name, tableOriginalFunc.key]);

  const [serchOpen, setSerchOpen] = useState(false);
  const aiChatOpen = useAtomValue(AppAtoms.aiChatOpen);
  const setAiChatOpenAtom = useSetAtom(AppAtoms.aiChatOpen);
  const [displayMode, setDisplayMode] = useState<
    "日別 / 月別" | "日別" | "月別"
  >("日別 / 月別");

  // 表示数・ページ
  const [displayNumber, setDisplayNumber] = useState(50);
  const displayNumbers = [25, 50, 100, 250, 500];
  const [pageNumber, setPageNumber] = useState(1);
  const [maxPageNumber, setMaxPageNumber] = useState(1);
  const firstYear = getFirstYear();
  const { thisYear, thisMonth, thisDay, lastYear, lastMonth } = getOneYear();
  const [firstLoading, setFirstLoading] = useState(true);

  // カラムデータの設定
  const [columnSetting, setColumnSetting] = useState<{
    status: "none" | "open" | "loading" | "result" | "error";
    columns: {
      id: number;
      screen_column_auth: 0 | 1;
      screen_column_system_default: 0 | 1;
      table_disabled: 0 | 1;
      screen_column_serch_disabled: 0 | 1;
      detail_disabled: 0 | 1;
      screen_column_name: string;
      screen_column_type: 0 | 1 | 2;
      table_sort: 0 | 1;
      screen_column_table: 0 | 1;
      table_column_size: string;
      screen_column_sort_id: number;
      screen_column_serch: 0 | 1;
      screen_column_detail: 0 | 1;
    }[];
  }>({
    status: "none",
    columns: [],
  });
  useEffect(() => {
    if (columnSetting.status === "loading") {
      setIsLoading(true);
    } else if (columnSetting.status !== "none") {
      setIsLoading(false);
    }
  }, [columnSetting]);

  async function openColumnSettingWindow() {
    setColumnSetting({
      ...columnSetting,
      status: "loading",
    });
    // 既存カラムの取得
    const { fetch_data } = await getScreenColumnAccountRunkings();
    setColumnSetting({
      status: "open",
      columns: fetch_data,
    });
  }

  async function putClumnSetting() {
    setColumnSetting({
      ...columnSetting,
      status: "loading",
    });
    const res = await putScreenColumnAccountRunkings(columnSetting.columns);
    if (res === "success") {
      setChangeTableData(false);
      setColumnLoading(true);
      await getTableData(true);
      const { accountRunkingScreenColumn } = await getScreenColumns();
      setAccountRunkingScreenColumn(accountRunkingScreenColumn);
      setColumnSetting({
        ...columnSetting,
        status: "result",
      });
    } else {
      setColumnSetting({
        ...columnSetting,
        status: "error",
      });
    }
  }

  function closeColumnSettingModal() {
    setColumnSetting({
      status: "none",
      columns: [],
    });
  }

  // 検索項目
  const serchColumn: { [key: string]: string } =
    accountRunkingTableColumn.dataColumn.reduce((column, difine) => {
      if (difine.serch === true) {
        if (difine.serchType === "date") {
          return {
            ...column,
            [difine.key + "_start"]: "",
            [difine.key + "_end"]: "",
          };
        } else if (difine.serchType === "runking_day") {
          return {
            ...column,
            runking_granularity_date:
              String(thisYear) +
              "-" +
              String(thisMonth).padStart(2, "0") +
              "-" +
              String(thisDay).padStart(2, "0"),
          };
        } else if (difine.key === "analysys_granularity") {
          return {
            ...column,
            [difine.key]: "日別",
          };
        } else {
          return {
            ...column,
            [difine.key]: "",
          };
        }
      } else {
        return {
          ...column,
        };
      }
    }, {});
  const [serchString, setSerchString] = useState(serchColumn);
  const [serchStringView, setSerchStringView] = useState(serchColumn);

  // ソート項目
  const [sortColumn, setSortColumn] = useState<
    {
      key: string;
      sort: string;
    }[]
  >([]);

  // 項目データ読み込み中フラグ
  const [columnLoading, setColumnLoading] = useState(true);
  useEffect(() => {
    if (accountRunkingScreenColumn.length > 0) {
      // ソート項目
      const sortColumn = accountRunkingScreenColumn
        .filter((column) => column.sort)
        .flatMap((column, index) => [
          {
            key: `monthly_${column.key}`,
            sort: "DESC",
            _group: 0,
            _index: index,
          },
          {
            key: `daily_${column.key}`,
            sort: "DESC",
            _group: 1,
            _index: index,
          },
        ])
        .sort((a, b) => a._group - b._group || a._index - b._index);
      setSortColumn(sortColumn);
      setColumnLoading(false);
    }
  }, [accountRunkingScreenColumn]);

  // テーブルデータ（統合データ：日別・月別が1つのレコードに含まれる）
  const [fetchData, setFetchData] = useState<dataDifine[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  async function getTableData(edit: boolean) {
    if (!edit) {
      setIsLoading(true);
    }
    const result = await getAccountRunkings(
      {
        ...serchString,
        displayNumber,
        pageNumber,
      },
      sortColumn,
    );
    if (result === null) {
      setFetchData([]);
      setTotalCount(0);
      setMaxPageNumber(1);
      setPageNumber(1);
    } else if (result) {
      setFetchData(result.accountRunkings);
      const countAccountRunkings = Number(result.countAccountRunkings);
      setTotalCount(countAccountRunkings);
      setMaxPageNumber(Math.ceil(countAccountRunkings / displayNumber));
    }
    if (!edit) {
      setIsLoading(false);
    }
    setFirstLoading(false);
  }

  async function getRankingXLSX() {
    const idToken = loginUser?.idToken;
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const nowTimeName = `${year}${month}${day}_${hours}${minutes}${seconds}`;
    const fileName = "ランキング_" + nowTimeName + ".xlsx";

    // search_params: 一覧GET(api/accountRunking.ts)と同一serialization(makeParams+axios)で生成
    const params = makeParams(accountRunkingTableColumn.dataColumn, { ...serchString, displayNumber, pageNumber });
    delete (params as any).displayNumber;
    delete (params as any).pageNumber;
    const search_params = axios.getUri({ url: "", params }).replace(/^\?/, "");

    const bodys = {
      type: "get_xlsx_ranking",
      search_params,
      fileName,
    };
    const url =
      CONST.outputXLSXRankingsWebSocketAPIURL + "?Authorization=" + idToken;
    const websocket = new WebSocket(url);
    let succeeded = false;
    let noProgressTimer: ReturnType<typeof setTimeout> | null = null;
    const clearNoProgressTimer = () => {
      if (noProgressTimer) { clearTimeout(noProgressTimer); noProgressTimer = null; }
    };
    const failXLSX = () => {
      if (succeeded) return;
      clearNoProgressTimer();
      setGetXLSXStatus({
        ...getXLSXStatus,
        status: "error",
        message: "出力に失敗しました。再度お試しください",
      });
      if (websocket.readyState === WebSocket.OPEN) websocket.close();
    };
    const armNoProgressTimer = () => {
      clearNoProgressTimer();
      noProgressTimer = setTimeout(failXLSX, 3 * 60 * 1000);
    };
    const onMessage = async (event_websocket: any) => {
      armNoProgressTimer();
      const decodedData = JSON.parse(event_websocket.data);
      if (decodedData.message === "success") {
        succeeded = true;
        clearNoProgressTimer();
        const url = decodedData.url;
        const link = document.createElement("a");
        link.href = decodedData.url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(url);
        link.parentNode?.removeChild(link);
        setGetXLSXStatus({
          ...getXLSXStatus,
          status: "result",
          message: "ランキング一覧出力完了",
        });
        websocket.close();
      } else if (
        decodedData.message !== "End_WebSocket_API" &&
        decodedData.message !== "Endpoint request timed out"
      ) {
        setGetXLSXStatus({
          ...getXLSXStatus,
          status: "getting",
          message: decodedData.message,
        });
      }
    };
    websocket.onmessage = onMessage;
    websocket.onopen = () => { armNoProgressTimer(); websocket.send(JSON.stringify(bodys)); };
    websocket.onclose = failXLSX;
  }

  // 初回データ取得
  useEffect(() => {
    if (firstLoading) {
      getTableData(false);
    }
  }, []);

  // テーブルデータの更新受付
  const [changeTableData, setChangeTableData] = useState(false);

  // 変更があったときのみ
  useEffect(() => {
    if (!firstLoading && changeTableData) {
      getTableData(false);
    } else if (columnLoading === false) {
      setChangeTableData(true);
    }
  }, [serchString, displayNumber, pageNumber, sortColumn]);

  // サブテーブルデータの登録結果（共通）
  const [onSubtableDataAddModalResult, setOnSubtableDataAddModalResult] =
    useState("");

  // サブサブテーブルデータの登録結果（共通）
  const [onSubSubtableDataAddModalResult, setOnSubSubtableDataAddModalResult] =
    useState("");

  // 上位店一覧
  const [highRankCompanyList, setHighRankCompanyList] = useState<
    { id: number; high_rank_company_name: string }[]
  >([]);
  const [highRankCompanyNameList, setHighRankCompanyNameList] = useState([""]);
  // 上位店一覧取得
  async function getHighRankCompanyList() {
    const fetchData = await getSerchHighRankCompanys();
    if (fetchData === null) {
      setHighRankCompanyList([]);
    } else if (fetchData) {
      setHighRankCompanyList(
        fetchData.highRankCompanys as {
          id: number;
          high_rank_company_name: string;
        }[],
      );
      let highRankCompanyNameList = [""];
      fetchData.highRankCompanys.map(
        (company: { id: number; high_rank_company_name: string }) => {
          if (
            !highRankCompanyNameList.includes(company.high_rank_company_name)
          ) {
            highRankCompanyNameList.push(company.high_rank_company_name);
          }
        },
      );
      setHighRankCompanyNameList(highRankCompanyNameList);
    }
  }

  // カテゴリ一覧
  const [categoryList, setCategoryList] = useState<
    { id: number; category_name: string }[]
  >([]);
  const [categoryNameList, setCategoryNameList] = useState([""]);
  async function getCategoryList() {
    const fetchData = await getSerchCategorys();
    if (fetchData === null) {
      setCategoryList([]);
    } else if (fetchData) {
      setCategoryList(
        fetchData.categorys as {
          id: number;
          category_name: string;
        }[],
      );
      let categoryNameList = [""];
      fetchData.categorys.map(
        (company: { id: number; category_name: string }) => {
          if (!categoryNameList.includes(company.category_name)) {
            categoryNameList.push(company.category_name);
          }
        },
      );
      setCategoryNameList(categoryNameList);
    }
  }

  // パートナー一覧
  const [companyList, setCampanyList] = useState<
    { id: number; sale_company_name: string }[]
  >([]);
  const [companyNameList, setCampanyNameList] = useState([""]);
  // パートナー一覧取得
  async function getSaleCompanysList() {
    const fetchData = await getSerchSaleCompanys();
    if (fetchData === null) {
      setCampanyList([]);
    } else if (fetchData) {
      setCampanyList(
        fetchData.saleCompanys as { id: number; sale_company_name: string }[],
      );
      let companyNameList = [""];
      fetchData.saleCompanys.map(
        (company: { id: number; sale_company_name: string }) => {
          if (!companyNameList.includes(company.sale_company_name)) {
            companyNameList.push(company.sale_company_name);
          }
        },
      );
      setCampanyNameList(companyNameList);
    }
  }

  // グループ一覧取得
  const [searchGroupList, setSearchGroupList] = useState<
    {
      id: number;
      group_name: string;
      sale_company_id: number;
    }[]
  >([]);
  const [searchGroupNameList, setSearchGroupNameList] = useState([""]);
  async function getSaleCompanyGroupsList() {
    const fetchData = await getSerchSaleCompanyGroups();
    if (fetchData === null) {
      setSearchGroupList([]);
    } else if (fetchData) {
      setSearchGroupList(
        fetchData.saleCompanyGroups as {
          id: number;
          group_name: string;
          sale_company_id: number;
        }[],
      );
      let searchGroupNameList = [""];
      fetchData.saleCompanyGroups.map(
        (company: { id: number; group_name: string }) => {
          if (!searchGroupNameList.includes(company.group_name)) {
            searchGroupNameList.push(company.group_name);
          }
        },
      );
      setSearchGroupNameList(searchGroupNameList);
    }
  }
  // 商材一覧
  const [productList, setProductList] = useState<
    {
      id: number;
      high_rank_company_id: number;
      product_name: string;
      high_rank_company_name: string;
      product_key: string;
    }[]
  >([]);
  const [productNameList, setProductNameList] = useState([""]);
  async function getProductList() {
    const fetchData = await getSerchProducts();
    if (fetchData === null) {
      setProductList([]);
    } else if (fetchData) {
      setProductList(
        fetchData.products as {
          id: number;
          high_rank_company_id: number;
          product_name: string;
          high_rank_company_name: string;
          product_key: string;
        }[],
      );
      let productNameList = [""];
      fetchData.products.map(
        (company: {
          id: number;
          high_rank_company_id: number;
          product_name: string;
        }) => {
          if (!productNameList.includes(company.product_name)) {
            productNameList.push(company.product_name);
          }
        },
      );
      setProductNameList(productNameList);
    }
  }
  // 営業アカウント一覧
  const [accountSaleList, setAccountSaleList] = useState<
    { id: number; account_name: string }[]
  >([]);
  const [accountSaleNameList, setAccountSaleNameList] = useState([""]);
  async function getSaleAccountSalesList() {
    const fetchData = await getSerchAccountSales();
    if (fetchData === null) {
      setAccountSaleList([]);
    } else if (fetchData) {
      setAccountSaleList(
        fetchData.accountSales as { id: number; account_name: string }[],
      );
      let accountSaleNameList = [""];
      fetchData.accountSales.map(
        (accountSale: { id: number; account_name: string }) => {
          if (!accountSaleNameList.includes(accountSale.account_name)) {
            accountSaleNameList.push(accountSale.account_name);
          }
        },
      );
      setAccountSaleNameList(accountSaleNameList);
    }
  }

  useEffect(() => {
    getHighRankCompanyList();
    getCategoryList();
    getProductList();
    getSaleAccountSalesList();
    getSaleCompanysList();
    getSaleCompanyGroupsList();
  }, []);

  // cmd-po_1168 SP排他: AI open時に検索を close
  useEffect(() => {
    if (aiChatOpen && isSmartPhone) setSerchOpen(false);
  }, [aiChatOpen, isSmartPhone]);
  const handleSetSerchOpen = (open: boolean) => {
    setSerchOpen(open);
    if (open && isSmartPhone) setAiChatOpenAtom(false);
  };

  return (
    <Box
      data-testid="account-runking-page"
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <PageTabs group="analytics" />
      <Box
        sx={{
          display: "flex",
          gap: "var(--sp-2, 8px)",
          alignItems: "stretch",
          flex: 1,
          minHeight: 0,
        }}
      >
        {(serchOpen || aiChatOpen) && isSmartPhone ? null : (
          <Box
            sx={{
              flex: 1,
              minWidth: 0,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <TableTopBar
              serch={true}
              serchOpen={serchOpen}
              setSerchOpen={handleSetSerchOpen}
              addDataNames={addDataNames}
              addDataName={addDataName}
              setAddDataName={setAddDataName}
              addCSVDataNames={addCSVDataNames}
              addCSVDataName={addCSVDataName}
              setAddCSVDataName={setAddCSVDataName}
              getXLSXDataNames={getXLSXDataNames}
              getXLSXDataName={getXLSXDataName}
              setGetXLSXDataName={setGetXLSXDataName}
              editDatasNames={editDatasNames}
              editDatasName={editDatasName}
              setEditDatasName={setEditDatasName}
              editIDs={[]}
              columnSettingOpen={columnSetting.status !== "none"}
              openColumnSettingWindow={openColumnSettingWindow}
                  totalCount={totalCount}
              onReload={() => getTableData(false)}
            />
            <TableRunking
              getTableData={getTableData}
              serchOpen={serchOpen}
              singleMode={
                displayMode === "日別 / 月別"
                  ? undefined
                  : displayMode === "日別"
                    ? "daily"
                    : "monthly"
              }
              tableColumn={accountRunkingTableColumn}
              dataColumn={accountRunkingScreenColumn}
              rows={fetchData}
              totalCount={totalCount}
              dailyDateLabel={`${serchString.runking_granularity_date.split("-").map(Number)[0]}年${serchString.runking_granularity_date.split("-").map(Number)[1]}月${serchString.runking_granularity_date.split("-").map(Number)[2]}日`}
              monthlyDateLabel={`${serchString.runking_granularity_date.split("-").map(Number)[0]}年${serchString.runking_granularity_date.split("-").map(Number)[1]}月`}
              displayNumber={displayNumber}
              setDisplayNumber={setDisplayNumber}
              displayNumbers={displayNumbers}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              maxPageNumber={maxPageNumber}
              tableTitle={accountRunkingTableColumn.title}
              sortColumn={sortColumn}
              setSortColumn={setSortColumn}
              productName={
                serchString.product_name === ""
                  ? "全商材"
                  : serchString.product_name
              }
            />
          </Box>
        )}
        {serchOpen ? (
          <SerchSideBar
            setSerchOpen={handleSetSerchOpen}
            tableColumn={accountRunkingTableColumn}
            dataColumn={accountRunkingScreenColumn}
            firstYear={firstYear}
            thisYear={thisYear}
            serchColumn={serchColumn}
            setSerchString={setSerchString}
            companyNameList={companyNameList}
            companyGroupNameList={searchGroupNameList}
            highRankCompanyNameList={highRankCompanyNameList}
            categoryNameList={categoryNameList}
            productNameList={productNameList}
            accountSaleNameList={accountSaleNameList}
            accountStaffNameList={[]}
            serchStringView={serchStringView}
            setSerchStringView={setSerchStringView}
            displayMode={displayMode}
            setDisplayMode={setDisplayMode}
            displayModeList={["日別 / 月別", "日別", "月別"]}
          />
        ) : null}
      </Box>
      <ColumnSettingModal
        onModal={
          columnSetting.status !== "none" && columnSetting.status !== "loading"
        }
        swCloseModal={closeColumnSettingModal}
        columnSetting={columnSetting}
        setColumnSetting={setColumnSetting}
        putClumnSetting={putClumnSetting}
      />
      <GetXLSXRankingModal
        onModal={getXLSXStatus.status !== "none"}
        swCloseModal={() => { setGetXLSXStatus({ status: "none", message: "" }); setGetXLSXDataName(""); }}
        getXLSXStatus={getXLSXStatus}
        setGetXLSXStatus={setGetXLSXStatus}
        getXLSXFunc={getRankingXLSX}
        totalCount={totalCount}
      />
    </Box>
  );
}

export default AccountRunking;
